module.exports = __webpack_public_path__ + "img/male.7b3b0165.png";